module.exports = __webpack_public_path__ + "img/features_pic01.0137980b.png";